/**
 * @generated SignedSource<<55812d660ebc3a712f5fff3499130362>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardContent_Inner_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_query">;
  readonly " $fragmentType": "BoardContent_Inner_query";
};
export type BoardContent_Inner_query$key = {
  readonly " $data"?: BoardContent_Inner_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardContent_Inner_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardContent_Inner_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardColumnOld_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "0076881955fd432b4e911f507f3f25f5";

export default node;
